// extracted by mini-css-extract-plugin
export default {"wrap":"tpwK9rjND_RtgDtxLhZO"};